import { styled } from '@mui/material/styles';

export const Subtitle = styled('h3')(({ theme, underlined, pointer }) => ({
  fontSize: theme.fontSize.large,
  margin: theme.spacing(0, 0, 2, 0),
  textAlign: 'left',
  padding: theme.spacing(1.5, 0),
  ...(underlined && { borderBottom: `1px solid ${theme.color.grey[500]}` }),
  ...(pointer && { cursor: 'pointer' })
}));
